<mat-form-field
  *ngIf="!readonly"
  class="w-100 currency"
  [ngClass]="{ 'allow-pointer': tooltipText, 'no-label': hideLabel }"
  [floatLabel]="'always'"
>
  <mat-label>
    {{ labelOverride || fgInfo?.label }}{{ formControl['condrequired'] || fgInfo?.required ? '*' : '' }}
    <mat-icon [hidden]="!tooltipText" [matTooltip]="tooltipText" [matTooltipPosition]="'after'" [attr.aria-label]="'Tooltip: ' + tooltipText" tabindex="0">
      help
    </mat-icon>
  </mat-label>
  <input
    type="number"
    [attr.data-automation-id]="dataAutomationId"
    [required]="fgInfo.required"
    matInput
    [placeholder]="placeholder"
    [formControl]="formControl"
    [value]="valueFormatted"
    (change)="formatCurrency(this)"
    (keydown)="onInputKeyDown($event)"
  />
  <span matPrefix>$&nbsp;</span>
  <mat-hint>{{ hint }}</mat-hint>
   <mat-error *ngIf="errorDefinitions?.length">
    <ng-container *ngFor="let errorDefinition of errorDefinitions">
      <span *ngIf="formControl?.touched && errorDefinition.showFunction() && errorDefinition.errorMessage(formControl)"> {{ errorDefinition.errorMessage(formControl) }}</span>
    </ng-container>
  </mat-error>
</mat-form-field>
<ng-container *ngIf="readonly">
  <mat-form-field
    class="no-underline w-100"
    [ngClass]="{ 'read-only': readonly, 'allow-pointer': tooltipText, 'no-label': hideLabel }"
    [floatLabel]="'always'"
  >
    <mat-label>
      {{ labelOverride || fgInfo?.label }}
      <mat-icon [hidden]="!tooltipText" [matTooltip]="tooltipText" [matTooltipPosition]="'after'" [attr.aria-label]="'Tooltip: ' + tooltipText" tabindex="0">
        help
      </mat-icon>
    </mat-label>
    <input
      readonly
      matInput
      [attr.data-automation-id]="dataAutomationId"
      [value]="formControl.value | currency"
      tabindex="-1"
    />
  </mat-form-field>
</ng-container>
